module.exports = __webpack_public_path__ + "img/logo.e04f4249.png";